<!-- <app-header></app-header>
<app-sidebar></app-sidebar> -->

<!-- <main class="full-wrap">
    <div class="main-div">
        <div class="left-section">
            <div class="report-page">
                <div class="page-title">
                    <h3>Account Statement</h3>
                    <div class="breadcrumb">
                        <a class="btn btn-secondary back-btn"><i class="fa fa-arrow-left"></i>Back</a>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
</main> -->
<!-- <main class="full-wrap dashboard-page">
    <div class="main-div">
        
        <div class="filterDiv">
            Account Details
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="report-table">
                    <table class="table" datatable>
                        <thead>
                           
                        </thead>
                        <tbody>
                          <tr>
                            <td>Name</td>
                            <td>{{userDetails?.name}}</td>
                          </tr>
                          <tr>
                            <td>Commission</td>
                            <td>{{userDetails?.match_commission}}</td>
                          </tr>
                          <tr>
                            <td>Exposure Limit</td>
                            <td>{{userDetails?.exposure_limit}}</td>
                          </tr>
                          <tr>
                            <td>Mobile Number</td>
                            <td>{{(userDetails?.mobile == null) ? 'Not Available' : userDetails?.mobile}}</td>
                          </tr>
                          <tr>
                            <td>Password</td>
                            <td><span class="mr-3">******</span>
                              <a (click)="openModalChangePwd(changePwd);"><i class="fa fa-pencil-square-o fa-lg"></i></a></td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="right-sidebar">
            <div>
                <div class="card open-bet mb-0 b-none">
                    <div class="card-header card-accrdn openbetlist">
                        <strong>Open Bets</strong>
                    </div>
                    <div class="card-body">
                        <div class=" col-md-1" style="width: 100%;margin-bottom:9px;">
                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch"
                                (change)="openBets(searchMatch) "
                                placeholder="Search Match Name" >
                                <ng-option *ngFor="let match of MatchList" [value]="match">{{match.match_name}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="table-responsive" *ngIf="openBetsLength != 0" style="font-size: 12px;">
                            <table class="table"  *ngIf="backData?.length != 0">
                                <thead>
                                    <tr>
                                        <th>Back (Bet For)</th>
                                        <th>Odds</th>
                                        <th>Stake</th>
                                        <th>Profit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let bet of backData;let i = index;">
                                            <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet.is_back == 0 ? 'Lay' : "Back"}}
                                                <span>{{bet?.selection_name}}</span><br>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{bet?.market_name}}</span>
                                            </td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.odds}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.stack}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.p_l | number : '0.0-2'}}</td>
                                        </tr>
                                    <tr *ngIf="openBetsLength == 0">
                                        No Record Found ....
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table"  *ngIf="layData?.length != 0">
                                <thead>
                                    <tr>
                                        <th>Back (Bet Against)</th>
                                        <th>Odds</th>
                                        <th>Stake</th>
                                        <th>Liability</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let bet of layData;let i = index;">
                                            <td *ngIf="bet.is_fancy == 0" [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet.is_back == 0 ? 'Lay' : "Back"}}
                                                <span style="max-width: 20px !important;
                                                width: 20px !important;
                                                text-overflow: ellipsis;">{{bet?.selection_name}}</span><br>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{bet?.market_name}}</span>
                                            </td>
                                            <td *ngIf="bet.is_fancy == 1" [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet.is_back == 0 ? 'Lay' : "Back"}}
                                                <span>{{bet?.market_name}}</span><br>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>Fancy</span>
                                            </td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.odds}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.stack}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}" style="color: red !important;">{{bet?.liability | number : '0.0-2'}}</td>
                                        </tr>
                                    
                                </tbody>
                            </table>
                           </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->

<!-- <ng-template #changePwd >
  <div class="modal-header">
      <h4 class="modal-title">Change Password</h4>
      <a type="button" class="close" data-dismiss="modal" (click)="modalRef.hide()" *ngIf="pass != true"><i class="fa fa-times"></i></a>
  </div>
  <form [formGroup]='changePasswordForm' (ngSubmit)='onSubmitChangePassword()'>
      <div class="modal-body no-scroll-body">
          <div class="body-inner">

              <div class="form-group">
                  <label class="form-label">Old Password</label>
                  <input type="password" placeholder="Old Password" class="form-control password-box"
                      formControlName='old_password'>
              </div>

              <div class="form-group">
                  <label class="form-label">New Password</label>
                  <input type="password" placeholder="Password" class="form-control password-box"
                      formControlName='new_password'>
              </div>

              <div class="form-group">
                  <label class="form-label">Confirm Password</label>
                  <input type="password" placeholder="Password" class="form-control password-box"
                      formControlName='confirm_password'>
              </div>

          </div>
      </div>

      <div class="modal-footer">
          <div class="text-end">
              <button type="submit" class="btn btn-success">Submit</button>
          </div>
      </div>
  </form>
</ng-template> -->


<div class="main-wrapper">
    <app-header></app-header>
    <div class="app-body position-relative">
        <app-sidebar></app-sidebar>
        <main class="main">
            <div class="row">
              <div class="col-md-12">
                <div class="divider-top">
                  <div class="card">
                    <div class="card-header account-detail-head">
                      Account Details
                    </div>
                    <div class="card-body account-detail-body">
                      <div class="bd-example">
                        <dl class="row">
                          <dt class="col-sm-3">Name</dt>
                          <dd class="col-sm-9">{{userDetails?.name}}</dd>
                          <dt class="col-sm-3">Commission</dt>
                          <dd class="col-sm-9">{{userDetails?.match_commission}}</dd>
                          <dt class="col-sm-3">Rolling Commission</dt>
                          <dd class="col-sm-9"><a (click)="openModalrollComission(rollComission);" data-bs-toggle="modal" class="text-success" role="button"><i class="fa fa-eye fa-lg"></i></a></dd>
                          <dt class="col-sm-3">Exposure Limit</dt>
                          <dd class="col-sm-9">{{userDetails?.exposure_limit}}</dd>
                          <dt class="col-sm-3">Mobile Number</dt>
                          <dd class="col-sm-9">{{(userDetails?.mobile == null) ? 'Not Available' : userDetails?.mobile}}</dd>
                          <dt class="col-sm-3">Password</dt>
                          <dd class="col-sm-9"><span class="me-3">*********</span><a (click)="openModalChangePwd(changePwd);" data-bs-toggle="modal" class="text-success edit-password" role="button"> Edit <i class="fa fa-pencil-square-o fa-lg"></i></a></dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </main>
        <app-right-sidebar></app-right-sidebar>                
    </div>
   <app-footer-main></app-footer-main>
</div>

<ng-template #changePwd>
    <!-- <div class="modal fade passwordModal" id="passwordModal" aria-hidden="true" aria-labelledby="passwordModalLabel" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content"> -->
            <div class="modal-header">
              <h5 class="modal-title">Change Password</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modalRef.hide()"></button>
            </div>
            <div class="modal-body" [formGroup]='changePasswordForm' (ngSubmit)='onSubmitChangePassword()'>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="mb-1">Old Password  <span class="asterisk_input"></span></label>
                    <input type="password" placeholder="Old Password" class="form-control"
                    formControlName='old_password'>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="mb-1">New Password  <span class="asterisk_input"></span></label>
                    <input type="password" placeholder="Password" class="form-control"
                    formControlName='new_password'>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-1">Confirm Password  <span class="asterisk_input"></span></label>
                    <input type="password" placeholder="Password" class="form-control"
                    formControlName='confirm_password'>
                  </div>
                </div>
              </div>     
            </div>
            <div class="modal-footer">                
              <button type="submit" class="btn btn-dark btn-sm" (click)="onSubmitChangePassword()">Yes</button>
              <button type="button" class="btn btn-light btn-sm" data-bs-dismiss="modal" (click)="modalRef.hide()">No</button>
            </div>                        
          <!-- </div>
        </div>
      </div> -->
</ng-template>

<ng-template #rollComission>
    <!-- <div class="modal fade commissionModal" id="commissionModal" aria-hidden="true" aria-labelledby="commissionModalLabel" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content"> -->
            <div class="modal-header">
              <h5 class="modal-title">Rolling Commission</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modalRef.hide()"></button>
            </div>
            <div class="modal-body">
                <div class="view-rolling row">
                  <label class="col-md-3 col-3 col-form-label">Fancy</label>
                  <div class="col-md-8 col-8 col-form-label"><span> 0</span></div>
                </div>
                <div class="view-rolling row">
                  <label class="col-md-3 col-3 col-form-label">Matka</label>
                  <div class="col-md-8 col-8 col-form-label"><span> 0</span></div>
                </div>
                <div class="view-rolling row">
                  <label class="col-md-3 col-3 col-form-label">Casino</label>
                  <div class="col-md-8 col-8 col-form-label"><span> 0</span></div>
                </div>
                <div class="view-rolling row">
                  <label class="col-md-3 col-3 col-form-label">Binary</label>
                  <div class="col-md-8 col-8 col-form-label"><span> 0</span></div>
                </div>
                <div class="view-rolling row">
                  <label class="col-md-3 col-3 col-form-label">Sportbook</label>
                  <div class="col-md-8 col-8 col-form-label"><span> 0</span></div>
                </div>
                <div class="view-rolling row">
                  <label class="col-md-3 col-3 col-form-label">Bookmaker</label>
                  <div class="col-md-8 col-8 col-form-label"><span> 0</span></div>
                </div> 
            </div>                
          <!-- </div>
        </div>
      </div> -->
</ng-template>

